'use strict';

angular.module('theme').directive('orderButton', function ($window, CartService, ArticleService, TrackerService) {
	return {
		restrict: 'E',
		templateUrl: 'component/order-button.html',
		scope: {
			productId: '@'
		},
		controller: function ($scope) {
			ArticleService.getProduct($scope.productId).then(function (product) {
				$scope.product = product;
				$scope.prices = product.prices;
			});

			$scope.select = function (servings) {
				CartService.add($scope.product, servings).then(function () {
					TrackerService.addToCart($scope.product);
					
					// redirect to cart
					$window.location.href = '/order/';
				});
			};
		}
	};
});
